<template>
    <div id="app">
      <Layout>
        <Header style="padding:0;width: 100%;position: fixed;z-index: 999;background: #fff;">
          <header-nav></header-nav>
        </Header>
        <Content style="margin-top: 64px">
          <router-view/>
        </Content>

        <Footer style="background-color:#1d1f35;padding-bottom:0;position:relative;z-index:0;">
          <foot></foot>
        </Footer>
      </Layout>
    </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

.ivu-layout-header {
  background: #fff;
  padding: 0 50px;
  height: 64px;
  line-height: 64px;
}
.ivu-layout-header>div {
    height:100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue